export const RepeatPeriod = {
  NoReminder: 'never',
  Daily: '1 day',
  Weekly: '1 week',
  Monthly: '1 month',
} as const;

export type RepeatPeriod = (typeof RepeatPeriod)[keyof typeof RepeatPeriod];

export const ScheduleRepeatPeriod = {
  Day: '1 day',
  Week: '7 days',
  Month: '1 mon',
} as const;

export type ScheduleRepeatPeriod = (typeof ScheduleRepeatPeriod)[keyof typeof ScheduleRepeatPeriod];

export const JournallingPeriod = {
  OneDay: '1 day',
  ThreeDays: '3 days',
  Weekly: '1 week',
} as const;

export type JournallingPeriod = (typeof JournallingPeriod)[keyof typeof JournallingPeriod];

export const OnTrakProduct = {
  ReQoL10a: '25edc875-a993-40f7-857c-5b7bd9548f48',
  ReQoL10b: '22b42ed4-7157-4322-9666-00f90193eac7',
  ReQoL20: 'd0f0e864-5772-487b-abd4-0b46d6869743',
} as const;

export const AllClinicianRole = {
  ORGANIZATION: 'organization',
  SITE: 'site',
  CLINICIAN: 'clinician',
  PROGRAM_ADMINISTRATION: 'program_administration',
} as const;

export const ExternalClinicianRole = {
  ORGANIZATION: 'organization',
  SITE: 'site',
  CLINICIAN: 'clinician',
} as const;

export const SiteClinicianRole = {
  SITE: 'site',
  CLINICIAN: 'clinician',
} as const;

export const UserOrganization = {
  OLH: '694e4e0f-63fd-4526-8bfa-0bd1713f29ba',
  APA: '8ceebcc8-2c82-49c7-ba46-1851079d10a0',
  OSI: '2e129b2f-d501-474e-bed1-6ebce470d7f7',
  ONTRAK: 'b52211b2-1971-4adb-8dad-c4ec4d552f3a',
} as const;

export const UserRole = {
  ADMIN: 'trycycle',
  ORGANIZATION: 'organization',
  SITE: 'site',
  CLINICIAN: 'clinician',
  PROGRAM_ADMINISTRATION: 'program_administration',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const UserDiagnosis = {
  OTHER: 'c53ba470-e49c-42ac-8c32-cf13b76af662',
} as const;

// keep numbers, used for comparing statuses
export const Status = {
  incomplete: -1,
  inactive: 0,
  low_risk: 1,
  medium_risk: 2,
  high_risk: 3,
  critical_risk: 4,
  null: 5,
} as const;

export type StatusKey = keyof typeof Status;

export const LikertScale = {
  None: 0,
  Slight: 1,
  Mild: 2,
  Moderate: 3,
  Severe: 4,
};

type LikertScale = (typeof LikertScale)[keyof typeof LikertScale];

export const LikertScaleDescription: Record<LikertScale, string> = {
  [LikertScale.None]: ' None (Not at all) ',
  [LikertScale.Slight]: 'Slight (Rare, less than a day or two)',
  [LikertScale.Mild]: 'Mild (Several days)',
  [LikertScale.Moderate]: 'Moderate (More than half the days)',
  [LikertScale.Severe]: 'Severe (Nearly every day)',
} as const;

export const CallResult = {
  BadNumber: 'Bad number',
  BusySignal: 'Busy signal',
  NoAnswer: 'No answer',
  ConnectedToHousehold: 'Connected to someone else at household',
  ConnectedToClient: 'Connected to the client',
} as const;
export type CallResult = (typeof CallResult)[keyof typeof CallResult];
